import {
  isColumnSortDirection,
  isDefaultColumnSort,
  nextColumnSort,
  parseColumnSort,
  type ColumnSort,
  type ColumnSortDirection,
} from '@/lib/column-sort'

export const JOBS_REPORT_SORT_COLUMNS = [
  'date_raised',
  'assigned_partner_name',
  'job_type',
  'location_id',
  'road_name',
  'town_county',
  'asset_location',
  'outcome',
  'aborted_reason',
  'severity',
  'sla_category',
] as const

export type JobsReportSortColumn = (typeof JOBS_REPORT_SORT_COLUMNS)[number]
export type JobsReportSortDirection = ColumnSortDirection

export type JobsReportSort = ColumnSort<JobsReportSortColumn>

export const DEFAULT_JOBS_REPORT_SORT: JobsReportSort = {
  column: 'date_raised',
  direction: 'desc',
}

const DEFAULT_DIRECTION: Record<JobsReportSortColumn, JobsReportSortDirection> =
  {
    date_raised: 'desc',
    assigned_partner_name: 'asc',
    job_type: 'asc',
    location_id: 'asc',
    road_name: 'asc',
    town_county: 'asc',
    asset_location: 'asc',
    outcome: 'asc',
    aborted_reason: 'asc',
    severity: 'asc',
    sla_category: 'asc',
  }

export const isJobsReportSortColumn = (
  value: string
): value is JobsReportSortColumn =>
  (JOBS_REPORT_SORT_COLUMNS as readonly string[]).includes(value)

export const isJobsReportSortDirection = isColumnSortDirection

export const parseJobsReportSort = (
  column: string | null,
  direction: string | null
): JobsReportSort =>
  parseColumnSort(column, direction, {
    columns: JOBS_REPORT_SORT_COLUMNS,
    defaultSort: DEFAULT_JOBS_REPORT_SORT,
    defaultDirection: DEFAULT_DIRECTION,
  })

export const isDefaultJobsReportSort = (sort: JobsReportSort) =>
  isDefaultColumnSort(sort, DEFAULT_JOBS_REPORT_SORT)

export const nextJobsReportSort = (
  current: JobsReportSort,
  column: string
): JobsReportSort =>
  nextColumnSort(current, column, {
    isColumn: isJobsReportSortColumn,
    defaultDirection: DEFAULT_DIRECTION,
  })
